
	    <div
			    class="form-group"
			    [formGroup]="OBJ_form_group"
			    [ngClass]="{'has-error': isInvalid()}">
		    <ng-template #tooltipTemplate>
			    <div [innerHtml]="getHint()|translate"></div>
		    </ng-template>
		    <label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
			    <i *ngIf="getHint()" class="fa fa-info-circle tig-tooltip-icon"
			       [tooltip]="tooltipTemplate"
			       placement="top"
			       triggers="click"
			       containerClass="tig-tooltip"
			       delay="50"></i> <span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
		    <div class="col-lg-8">
			    <tig-tags-input
					    class="form-control"
					    [ngClass]="OBJ_field_config?.readonly?'tig-disabled':''"
					    [OBJ_field_config]="OBJ_field_config"
					    [formControlName]="OBJ_field_config.name"
					    (onTagsChanged)="handleChanged($event)"
					    [BOO_objectTags]="false"
					    [BOO_readonly]="OBJ_field_config?.readonly"
					    [STR_placeholder]="(OBJ_field_config?.placeholder||'oFormList.sAddNewTag')|translate"
					    [STR_secondaryPlaceholder]="'oFormList.sAddTag'|translate"
					    (onInputValidation)="handleValidation($event)"
			    ></tig-tags-input>
			    <span class="help-block m-b-none color-red" *ngIf="STR_validation_message.length > 0">{{ STR_validation_message | translate }}</span>
				<div class="tig-hint" *ngIf="OBJ_field_config.note">
					<span>{{ OBJ_field_config.note|translate}}</span>
				</div>
			    <tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
		    </div>
	    </div>
    